import { Frequency } from 'modules/contribution/types'

export const SHOW_CUSTOM_AMOUNT = 'SHOW_CUSTOM_AMOUNT'
export const HIDE_CUSTOM_AMOUNT = 'HIDE_CUSTOM_AMOUNT'
export const SET_CUSTOM_AMOUNT = 'SET_CUSTOM_AMOUNT'
export const SET_AMOUNT = 'SET_AMOUNT'
export const SET_FREQUENCY = 'SET_FREQUENCY'

type ActionFrequency = {
  type: typeof SET_FREQUENCY
  payload: {
    frequency: Frequency
  }
}
type ActionShowCustomAmount = {
  type: typeof SHOW_CUSTOM_AMOUNT
}
type ActionHideCustomAmount = {
  type: typeof HIDE_CUSTOM_AMOUNT
}
type ActionSetCustomAmount = {
  type: typeof SET_CUSTOM_AMOUNT
  payload: {
    amount: number
  }
}
type ActionSetAmount = {
  type: typeof SET_AMOUNT
  payload: {
    amount: number
  }
}
export type Actions =
  | ActionFrequency
  | ActionShowCustomAmount
  | ActionHideCustomAmount
  | ActionSetCustomAmount
  | ActionSetAmount
